var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMotorcycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 12 2 L 12 4 L 14.300781 4 L 15.228516 6.5371094 L 13.837891 7 L 11 7 A 1.0001 1.0001 0 0 0 10.292969 7.2929688 L 8.5859375 9 L 6 9 L 4 9 L 2 9 L 2 11 L 4 11 L 4 12.050781 C 1.7620407 12.304527 0 14.197514 0 16.5 C 0 18.973437 2.0265633 21 4.5 21 C 6.9734367 21 9 18.973437 9 16.5 C 9 16.272263 8.9647678 16.052912 8.9316406 15.833984 L 13.195312 14.980469 A 1.0001 1.0001 0 0 0 13.986328 14.164062 L 14.886719 8.7597656 L 15.916016 8.4160156 L 17.421875 12.535156 C 15.991607 13.291295 15 14.778882 15 16.5 C 15 18.973437 17.026563 21 19.5 21 C 21.973437 21 24 18.973437 24 16.5 C 24 14.026563 21.973437 12 19.5 12 C 19.452602 12 19.408387 12.012195 19.361328 12.013672 L 17.894531 8 L 21 8 L 21 6 L 17.162109 6 L 15.939453 2.65625 A 1.0001 1.0001 0 0 0 15 2 L 12 2 z M 11.414062 9 L 12.820312 9 L 12.126953 13.154297 L 8.1914062 13.941406 C 7.6586419 13.176759 6.8905699 12.598894 6 12.279297 L 6 11 L 9 11 A 1.0001 1.0001 0 0 0 9.7070312 10.707031 L 11.414062 9 z M 4.5 14 C 5.8925565 14 7 15.107443 7 16.5 C 7 17.892557 5.8925565 19 4.5 19 C 3.1074435 19 2 17.892557 2 16.5 C 2 15.107443 3.1074435 14 4.5 14 z M 19.5 14 C 20.892557 14 22 15.107443 22 16.5 C 22 17.892557 20.892557 19 19.5 19 C 18.107443 19 17 17.892557 17 16.5 C 17 15.107443 18.107443 14 19.5 14 z",
    fill: "#000000"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorcycle);
export default __webpack_public_path__ + "static/media/motorcycle.190ff7772351c70abe81e74d3dd71495.svg";
export { ForwardRef as ReactComponent };